import React from 'react';
import './Legal.css';

export default function CGU() {
  return (
    <div className="legal-page">
      <h1>Conditions Générales d’Utilisation (CGU)</h1>
      <p><strong>Dernière mise à jour : Décembre 2025</strong></p>

      <h2>1. Objet</h2>
      <p>
        Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet de définir
        les règles d’accès et d’utilisation du site Aaz Store.
        En naviguant sur le site, l’utilisateur accepte pleinement les présentes CGU.
      </p>

      <h2>2. Description du site</h2>
      <p>
        Aaz Store est un site de vente en ligne de vêtements, chaussures et accessoires
        pour hommes. Le site permet de consulter les produits, passer commande
        et contacter le service client.
      </p>

      <h2>3. Accès au site</h2>
      <p>
        Le site est accessible gratuitement à tout utilisateur disposant d’un accès
        à Internet. Aaz Store s’efforce d’assurer un accès continu mais ne garantit
        pas une disponibilité permanente.
      </p>

      <h2>4. Utilisation du site</h2>
      <p>L’utilisateur s’engage à :</p>
      <ul>
        <li>Utiliser le site de manière légale et respectueuse</li>
        <li>Ne pas porter atteinte au bon fonctionnement du site</li>
        <li>Ne pas tenter d’accéder frauduleusement aux systèmes du site</li>
        <li>Ne pas utiliser le site à des fins illégales ou frauduleuses</li>
        <li>Fournir des informations exactes lors des commandes</li>
      </ul>

      <h2>5. Propriété intellectuelle</h2>
      <p>
        Tous les contenus présents sur le site (textes, images, logos, photos,
        design, marques) sont la propriété exclusive d’Aaz Store.
        Toute reproduction ou utilisation sans autorisation préalable est interdite.
      </p>

      <h2>6. Responsabilité</h2>
      <p>
        Aaz Store ne pourra être tenu responsable des dommages résultant de l’utilisation
        du site, notamment en cas de panne, interruption, erreur technique ou problème
        de connexion Internet.
      </p>

      <h2>7. Liens externes</h2>
      <p>
        Le site peut contenir des liens vers des sites tiers.
        Aaz Store n’exerce aucun contrôle sur ces sites et décline toute responsabilité
        concernant leur contenu.
      </p>

      <h2>8. Données personnelles</h2>
      <p>
        Les informations personnelles collectées sont utilisées uniquement pour
        le traitement des commandes et la communication avec les clients.
        Aaz Store s’engage à ne pas divulguer ces données à des tiers.
      </p>

      <h2>9. Cookies</h2>
      <p>
        Le site peut utiliser des cookies pour améliorer l’expérience utilisateur.
        L’utilisateur peut configurer son navigateur pour refuser les cookies,
        ce qui peut limiter certaines fonctionnalités.
      </p>

      <h2>10. Modification des CGU</h2>
      <p>
        Aaz Store se réserve le droit de modifier les présentes CGU à tout moment.
        Les nouvelles conditions s’appliquent dès leur publication sur le site.
      </p>

      <h2>11. Droit applicable</h2>
      <p>
        Les présentes CGU sont régies par le <strong>droit en vigueur au Niger</strong>.
        En cas de litige, une solution amiable sera recherchée en priorité.
      </p>

      <h2>12. Contact</h2>
      <p>
        Pour toute question ou réclamation :
        <br />
        <strong>Email :</strong> aazstore.niam@gmail.com
      </p>
    </div>
  );
}
